<template>
  <div class="dashboard-home">
    <BaseContainer
      :permission-list="['registry_manager']"
    >
      <template v-slot:header-title>
        Gestão de Registro
      </template>
      <div class="app-align-items-center mb-4">
        <v-select
          id="qa-id-name-role-list"
          v-model="selectedRole"
          :items="roleList"
          :rules="[isValid]"
          item-value="value"
          item-text="text"
          label="Perfil de usuário"
          style="max-width: 200px;"
          class="mr-2"
        />
        <v-autocomplete
          id="qa-id-name-program-list"
          v-model="selectedProgram"
          :items="programList"
          return-object
          item-value="id"
          item-text="name"
          label="Selecione o programa"
          :rules="[isValid]"
          style="max-width: 250px;"
          class="mr-2"
          clearable
        />
      </div>
      <template v-if="!hideDashboard">
        <v-tabs
          v-model="tab"
          background-color="transparent"
          class="mt-2"
        >
          <v-tab>Financeiro</v-tab>
          <v-tab>Operacional</v-tab>
        </v-tabs>

        <v-tabs-items
          v-model="tab"
          style="background:transparent;"
        >
          <v-tab-item
            v-for="tabItem, tabIndex in configurationId"
            :key="tabIndex"
            class="pt-6"
            :transition="false"
          >
            <BaseDashboard
              :selected-role="selectedRole"
              :selected-program="selectedProgram"
              :selected-configuration-id="configurationId[tab]"
            />
          </v-tab-item>
        </v-tabs-items>
      </template>
      <div
        v-else
        class="my-12"
      >
        Não há dados para exibir. Utilize os filtros acima para buscar novos dados.
      </div>
    </BaseContainer>
  </div>
</template>

<script>
import {mapState, mapActions} from "vuex"
import BaseContainer from '../BaseContainer'
import BaseDashboard from '../BaseDashboard'

export default {
  components: { BaseContainer, BaseDashboard },
  data: () => ({
    selectedProgram: null,
    selectedRole: 'owner',
    roleList: [ { text: 'Gestor', value: 'owner' } ],
    tab: 0,
    configurationId: ["dashboard_url_registry_finance_", "dashboard_url_registry_operation_"]
  }),
  computed: {
    ...mapState({
      allPrograms: state => state.platformProgram.allPrograms
    }),
    programList() {
      return this.allPrograms.filter(elem => elem.is_owner)
    },
    hideDashboard(){
      return !this.selectedProgram || !this.selectedRole || !this.hasDash
    },
    hasDash(){
      let list = []
      if(this.selectedRole && this.selectedProgram.configuration){
        Object.keys(this.selectedProgram.configuration).forEach(key => {
          if(key.includes(`dashboard_url_registry_finance_${this.selectedRole}`) || key.includes(`dashboard_url_registry_operation_${this.selectedRole}`)){
            list.push(this.selectedProgram.configuration[key])
          }
        })
        return list.length ? true : false
      } return false
    }
  },
  watch:{
    selectedProgram: {
      async handler(value) {
        this.tab = 0
      },
      deep: true
    },
    selectedRole () {
      this.tab = 0
    },
  },
  created(){
    this.apiGetAllPrograms()
  },
  methods: {
    ...mapActions(["apiGetAllPrograms"])
  }
}
</script>
